<p><marquee>{{ 'dataSubs.Dear DGC member, for your kind information marking of attendance is compulsory. Without marking of attendance report will not be submitted.' | translate }}</marquee></p>
<div class="card">
  <spinner [id]="'editexcel'" [show]='activeSpinner'></spinner>
  <div class="card-body" style="padding-top:6px; padding-bottom: 25px;">
    <div class="row">
      <div class="col-md-12 pt-0">
        <h5 class="border-bottom pb-1 mb-1">{{'submitdata.forminput' | translate }}</h5>
      </div>
      <div class="col-md-12 d-flex justify-content-start mt-2">
        <div class="form-group mr-3">
          <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="formInputfilter['ay']" class="form-control custom-selectbox"
            (change)="yearchanged(formInputfilter['ay'])">
            <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
          </select>
        </div>
        <div class="form-group mr-3">
          <label>{{'dataSubs.month' | translate }}<span class="required-field">*</span>
          </label>
          <select [(ngModel)]="formInputfilter['montharray']" (change)="changeMonth($event.target.value)" class="form-control custom-selectbox">
            <option value="" [disabled]="true">{{'monthmaps.selcecttag' | translate }}</option>
            <option *ngFor="let month of monthsList" [value]="month.key">
              {{'monthmaps.' + month['value'] | translate}}
            </option>
          </select>
        </div>
        <div class="form-group mr-3">
          <!-- <label *ngIf="userdetails['roles'][0]=='STATE_NODAL_OFFICER'">State</label> -->
          <label *ngIf="userdetails['roles'][0]=='DISTRICT_GANGA_COMMITTEE'">{{'header.district' | translate }}<span class="required-field">*</span></label>
          <select [(ngModel)]="formInputfilter['lu']" disabled="" class="form-control custom-selectbox">
            <!-- <option value="">Select State</option> -->
            <!-- <option *ngFor="let state of userdetails['loggedUserData']['userProfile']['associatedlocationsDetails']"
              value="{{state['entityUUID']}}">{{'districtsdata.' + state['entityName'] | translate}}</option> -->
              <option value="{{userdetails['loggedUserData']['userProfile']['locationId']}}">{{'districtsdata.' + userdetails['loggedUserData']['userProfile']['locationName'] | translate}}</option>
          </select>
        </div>
        <div class="form-group mr-3" *ngIf="showdistdropdown && formInputfilter['datasubmit'] == 'districtwise'">
          <label>District</label>
          <select [(ngModel)]="formInputfilter['distuuid']" class="form-control custom-selectbox">
            <option value="">Select District</option>
            <option *ngFor="let district of fieldDropDownList['DistrictList']" value="{{district['uuid']}}">
              {{'districtsdata.' + district['name'] | translate}}</option>
          </select>
          <span style="color:red" [hidden]="validation[1]">{{ 'districtsdata.pleaseselectdistrict' | translate }} </span>
        </div>
        <div class="form-group" style="margin-top: auto;">
          <label class="w-100">&nbsp;&nbsp;</label>
          <button class="btn btn-info pointer" (click)="getcurrentBusinessData()" type="submit"
            [disabled]="disableedit">{{'submitdata.add' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body" *ngIf="viewform" style="padding-top:5px;">
    <div id="forminput" role="tabpanel" class="tab-pane">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3 " style="padding-left: 0px; padding-right:6px; ">
          <div class="card">
            <ul class="nav sidebarnav flex-column ">
              <li class="nav-item pointer">
                <a (click)="fetchmeetingData()">
                  <i class="fas mr-2"></i>
                  {{'themedataObj.' + fetchData[10]['label'] | translate}}<span class="required-field">*</span>
                </a>
              </li>
              <!-- <li class="nav-item pointer" *ngIf = "!loginUserStatus" >
                <a (click)="collapseAll()" (click)="togg()">
                  <i  class="fas mr-2" [ngClass]="toggle_menu ? 'fa-chevron-right' : 'fa-chevron-down'" ></i>
                  {{fetchData[0]['sno']}} &nbsp; {{'themedataObj.' + fetchData[0]['label'] | translate}}
                </a>
                <ul *ngIf="!toggle_menu" class="nav flex-column ml-4">
                  <li *ngFor="let themeData of indicatorList;let i=index;" class="nav-item pointer"
                    (click)="fetchSubIndicator(themeData)">
                    <a class="nav-link">
                      <i></i>
                      {{themeData['sno']}} &nbsp;<span [ngClass]="{'selectedTheme': this.currentId == themeData['entityUUID']}">{{'indicatorlist.' + themeData['label'] | translate}}</span>
                    </a>
                  </li>
                </ul>

              </li> -->
              <ng-container>
                <li class="nav-item pointer" *ngFor = "let theme of fetchData ;let i=index;">
                  <a [ngClass]="{active: i == 0}" (click)="submitStatus?collapseAll(theme):null;Message(submitStatus)" *ngIf="theme['sno'] != 'K' ">
                    <i class="fas mr-2" [ngClass]="theme['open'] ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                    {{theme['sno']}} &nbsp; {{checkThemeName(theme['label'])?('themedataObj.' +theme['label'] | translate):theme['label']}}
                    <span class="required-field" *ngIf="theme['mandate']">*</span>
                  </a>
                  <ul class="nav flex-column ml-4" *ngIf = "theme['open']">
                    <li *ngFor="let themeData of theme['childList'];let i=index;" class="nav-item pointer"
                      (click)="fetchSubIndicator(themeData)">
                      <a class="nav-link">
                        <i></i>
                        {{themeData['sno']}} &nbsp;{{checkIndicator(themeData['label'])?('indicatorlist.' +themeData['label'] | translate):themeData['label']}}
                      </a>
                    </li>
                  </ul>
  
                </li>
              </ng-container>
              
            </ul>

          </div>
        </div>
        <ng-template #alertModal>
          <!-- <div class="modal-header d-flex justify-content-center p-4">
            <h3>alert</h3>
              <button type="button" (click)="CloseWindowModal()" class="close" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div> -->
          <div class="modal-body">
            <button type="button" (click)="CloseWindowModal()" class="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h3 style="background-color:rgb(188, 220, 248);color:black">{{ 'submitdata.Please fill all the required details in Meeting at DGC section' | translate}}</h3>
          </div> 
        </ng-template>

        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9" style="padding-left: 0px; padding-right:0px">
          <div class="card border-0" style="min-height:555px">
            <div class="card statistic-data shadow mb-1 p-1" >
              <h5 class="text-center d-block p-2 " style="color: #3688DB;" *ngIf="!indicatorflag" >{{indicatorThemes['sno']}} {{'indicatorlist.' +indicatorThemes['label'] | translate}}</h5>
              <div class="form-group" align="right" *ngIf="showbuttons && !meetingdateobj ">   
                <button [disabled]="prevbutton" class="btn btn-info ml-10" [hidden]="indicatorflag" type="submit"
                  (click)="getloginBased()">{{'submitdata.previous' | translate}}</button>&nbsp;&nbsp;&nbsp;&nbsp;
                <button [disabled]="nextbutton" class="btn btn-info pointer" [hidden]="indicatorflag" type="submit"
                  (click)="getnextloginBased()">{{'submitdata.next' | translate}}</button>
              </div>
              <div class="table-responsive">
              </div>
                <table class="table">
                  <tbody>
                    <tr [hidden]="indicatorflag">
                      <td style="width: 3%;" *ngIf="indicatorThemes!=null && indicatorremove &&!educatinglabel&&!gangalabel">{{indicatorThemes ? indicatorThemes['sno'] :'-'}}</td>
                        <td style="text-align: left; width: 47%;" *ngIf="indicatorThemes!=null && indicatorremove && !educatinglabel &&!gangalabel">
                          {{checkIndicator(indicatorThemes['label'])?('indicatorlist.' +  indicatorThemes['label'] | translate):indicatorThemes['label']}}
                        </td>
                        <td *ngIf="indicatorThemes!=null && indicatorremove &&!educatinglabel&&!gangalabel" style="width:120px">
                         <span *ngIf="indicatorThemes['ip'] == 'DOUBLE'">
                          
                          <input class="input-style p-0" [(ngModel)]="indicatorThemes['value']"
                            (ngModelChange)="themeValueChange(indicatorThemes)" name="comments" placeholder=""
                            style="width: 100%;" type="text" id="#13343" appFloatwithMinmax max="100">
                         </span>

                         <span *ngIf="indicatorThemes['ip'] == 'BOOLEAN'">
                          <input type="radio" name="indicatorThemes['sno']" [(ngModel)]="indicatorThemes['value']"
                            (ngModelChange)="booleanValueChange(indicatorThemes,'boolean')" value="yes"> {{ 'dataSubs.Yes' | translate }}
                          <input type="radio" name="indicatorThemes['sno']" [(ngModel)]="indicatorThemes['value']"
                            (ngModelChange)="booleanValueChange(indicatorThemes,'boolean')" value="no"> {{ 'dataSubs.No' | translate }}
                         </span>
    
                       </td>
                        <!-- <td> -->
                        <div style="text-align: left;"
                          *ngIf="indicatorThemes['label'] == 'Regular cleaning of Ghats is happening / Frequency' && indicatorThemes['value'] == 'yes'">
                          {{ 'hardtable.Frequency of cleaning' | translate }}</div>
                        <span
                          *ngIf="indicatorThemes['label'] == 'Regular cleaning of Ghats is happening / Frequency' && indicatorThemes['value'] == 'yes'">
                          <input class="input-style p-0" [(ngModel)]="indicatorThemes['foc']" name="comments"
                            placeholder="" type="text" id="#13343">
                        </span>
                        <div style="text-align: left;"
                          *ngIf="indicatorThemes['label'] == 'Status and availability of Ganga Praharis, Ganga Mitra/ Volunteer' && indicatorThemes['value'] == 'no'">
                          {{ 'hardtable.Action taken for it' | translate }}</div>
                        <span
                          *ngIf="indicatorThemes['label'] == 'Status and availability of Ganga Praharis, Ganga Mitra/ Volunteer' && indicatorThemes['value'] == 'no'">
                          <input class="input-style p-0" [(ngModel)]="indicatorThemes['action']" name="comments"
                            placeholder="" style="width: 100%;" type="text" id="#13343">
                        </span>
                        <div style="text-align: left;"
                          *ngIf="indicatorThemes['label'] == 'Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)' && indicatorThemes['value'] == 'yes'">
                          {{ 'comments.Number of meetings held' | translate }}</div>
                        <span
                          *ngIf="indicatorThemes['label'] == 'Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)' && indicatorThemes['value'] == 'yes'">
                          <input class="input-style p-0" [(ngModel)]="indicatorThemes['nomh']" name="comments"
                            placeholder="" type="text" id="#13343" appDigitsOnly autocomplete="off">
                        </span>
                        <div style="text-align: left;"
                          *ngIf="indicatorThemes['label'] == 'Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)' && indicatorThemes['value'] == 'yes'">
                          {{ 'comments.Name of Industries' | translate}}</div>
                        <span
                          *ngIf="indicatorThemes['label'] == 'Whether regular meetings are held with industries (If Yes- No of meetings held and name of industries)' && indicatorThemes['value'] == 'yes'">
                          <input class="input-style p-0" [(ngModel)]="indicatorThemes['noi']" name="comments"
                            placeholder="" type="text" id="#13343" autocomplete="off">
                        </span>
                        <div style="text-align: left;"
                          *ngIf="indicatorThemes['label'] == 'Whether regular cleaning / disposal of solid waste undertaken and monitored in all ULBs within the district' && indicatorThemes['value'] == 'yes'">
                          {{ 'comments.Frequency of Cleaning' | translate }}</div>
                        <span
                          *ngIf="indicatorThemes['label'] == 'Whether regular cleaning / disposal of solid waste undertaken and monitored in all ULBs within the district' && indicatorThemes['value'] == 'yes'">
                          <input class="input-style p-0" name="comments" [(ngModel)]="indicatorThemes['foc']" placeholder="" style="width: 100%;" type="text"
                            id="#13343">
                        </span>
                        <!-- </td> -->
                       <td style=" text-align: center; width:40%;" 
                        *ngIf="dynamicindLabel || inspectionlabel || authoritylabel || solidwastehotspot || plasticwastehotspot || adequatelabel || igolabel || soilconvlabel || stablisedlabel || gannurlabel || medicinelabel || capacitylabel || stpmanage || fecalsludge || regularmeetinglabel || dgclabel || gangaaarti || gangaapp || awarenesss || migratorylabel || gangasafety || yearlylabel || masterlabel || rivercentric || planlabel|| ngoLabel|| swachsurukshen || engagedlabel">
                        <!-- <div *ngIf="selectedFile =='' && fileId!=indicatorThemes.entityUUID ;else elseBlock"  [ngClass]="{'uploaddisable' : indicatorThemes['value']=='no'}"> -->
                        <div *ngIf="fileId!=indicatorThemes.entityUUID ;else elseBlock"  [ngClass]="{'uploaddisable' : indicatorThemes['value']=='no'}">
                          <label *ngIf="indicatorThemes['fileUUID']==null" class="form-control" for="files2" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                          <label *ngIf="indicatorThemes['fileUUID']!=null" class="form-control" for="files2" style="cursor: pointer;">{{indicatorThemes['fileName']}}</label>
                          <input type="file" id="files2" [disabled]="indicatorThemes['value'] == 'no' ? true : false" 
                            (change)="indicatorFileUpload($event,indicatorThemes.entityUUID)" style=" padding:3px;"
                            value="Browse" name="Browse" class="form-control float-right" hidden>
                        </div>
                        <div [ngClass]="{'uploaddisable' : indicatorThemes['value']=='no'}">
                          <ng-template #elseBlock>
                            <div class="d-flex justify-content-start" class="form-control float-right"
                              *ngIf="fileId ==  indicatorThemes.entityUUID; else elsetemp">
                              <label for="fileInput11" style="cursor: pointer;">{{indicatorThemes['selectedFile']}}</label>
                              <input id="fileInput11" type="file" 
                                (change)="indicatorFileUpload($event,indicatorThemes.entityUUID)" hidden>
                            </div>
                          </ng-template>
                        </div>
                        <ng-template #elsetemp>
                          <label class="form-control" for="files3" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                          <input type="file" id="files3"
                            (change)="indicatorFileUpload($event,indicatorThemes.entityUUID)" style=" padding:3px;"
                            value="Browse" name="Browse" class="form-control float-right" hidden>
                          <!-- <span style="color:red;" class="pr-20" [hidden]="!row['showFileError']">Please upload
                              supporting document</span> -->
                        </ng-template>
                        <!-- <span  style="color:red;" class="pr-20" [hidden]="!row['showFileError']">Please upload supporting document</span> -->
                      </td>
                      <td *ngIf="indicatorThemes['fileupload']== true">
                        <button class="btn btn-danger" (click)="indicatorfileRemove()"  type="submit">{{'submitdata.Remove' | translate}}</button>
                      </td>
                      <!-- <td style="width: 120px; text-align: center;"
                        *ngIf="gangalabel ||  educatinglabel ||ulblabel || inspectionlabel || authoritylabel || solidwastehotspot || plasticwastehotspot || adequatelabel || igolabel || soilconvlabel || stablisedlabel || gannurlabel || medicinelabel || capacitylabel || stpmanage || fecalsludge || regularmeetinglabel || dgclabel || gangaaarti || gangaapp || awarenesss || migratorylabel || gangasafety || yearlylabel || masterlabel || rivercentric">
                        <input type="file" (change)="indicatorFileUpload($event,indicatorThemes.entityUUID)"
                          style="width: 110px; padding:3px;" value="Browse" name="Browse"
                          class="form-control float-right"> -->
                      <!-- <span  style="color:red;" class="pr-20" [hidden]="!row['showFileError']">Please upload supporting document</span> -->
                      <!-- </td> -->
                      <!-- <td *ngIf = "mediaLabels">Link Sharing Option</td> -->
                    </tr>

                    <tr [hidden]="indicatorflag" *ngFor="let row of activeSubIndicators">
                      
                      <td *ngIf="row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional'  &&  row['label']!='Rescue operation for endangered species have been done'">
                        {{row['sno'] ? row['sno'] : row['snu']}}
                      </td>
                      <td *ngIf="row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional'  && row['label']=='Rescue operation for endangered species have been done' && indicatorThemes['value']=='yes' "> 
                        {{row['sno'] ? row['sno'] : row['snu']}} 
                      </td>
                      <!-- <td *ngIf = "row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional'"></td> -->
                      <td *ngIf="row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional' && row['label']!='Rescue operation for endangered species have been done'"><!--&& indicatorThemes['value']='yes'-->
                        <table class="table">
                          <tr>
                            <td class="text-left"
                              *ngIf="row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional' && row['label']!='Rescue operation for endangered species have been done'"
                              style="width:50%;padding: 0 15px;">
                              {{checkSubIndicator(row['label'])?('subindlist.' + row['label'] | translate):row['label']}}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <div style="text-align: left;"
                                *ngIf="row['label'] == 'Mass awareness meetings held (If Yes- No of meetings held)' && row['value'] == 'yes'">
                                {{ 'comments.Number of meetings held' | translate}}</div>
                              <span
                                *ngIf="row['label'] == 'Mass awareness meetings held (If Yes- No of meetings held)' && row['value'] == 'yes'">
                                <input class="input-style p-0" name="comments" [(ngModel)]="row['nomh']" placeholder="" style="width: 50%;" appDigitsOnly
                                  type="text" id="#13343" [min]="row['min']" [max]="row['max']">
                              </span>
                              <!-- <div style="text-align: left;"
                                *ngIf="row['label'] == 'Other - Mention It - Like Ganga Run, Painting Competetion' && row['value'] == 'yes'">
                                Other Activities</div>
                              <span
                                *ngIf="row['label'] == 'Other - Mention It - Like Ganga Run, Painting Competetion' && row['value'] == 'yes'">
                                <input class="input-style p-0" name="comments" placeholder="" style="width: 50%;"
                                  type="text" id="#13343" [min]="row['min']" [max]="row['max']">
                              </span> -->
                              
                            </td>
                            <!-- <td *ngIf="row['label']=='Rescue operation for endangered species have been done' && indicatorThemes['value']=='yes' " style="width:50%;padding: 0 15px;">
                              {{checkSubIndicator(row['label'])?('subindlist.' + row['label'] | translate):row['label']}}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                            </td> -->
                            
                            <td *ngIf="row['ip'] == 'DOUBLE'" style="width:auto;">
                              
                              
                                <div class="justify-content-start">
                                  <!-- <div>
                                    <ng-container *ngIf = "row['subindflag']">
                                        <span *ngFor = "let subinddata of row['valueData']">
                                                <br><br>
                                                <b>{{subinddata['value']}}</b>
                                            </span>
                                </ng-container>
                                </div> -->
                                
                                <div *ngIf="row['label'] == 'Percentage of Ganga Grams declared ODF'">
                                  <input class="input-style p-0" name="comments" placeholder="" style="width: 100%;"
                                      (keypress)="allowingValuesinput($event,row)" type="text" id="#13343"
                                      max="100" appFloatwithMinmax autocomplete="off"  appBlockcopyPaste
                                      [(ngModel)]="row['value']" (ngModelChange)="indicatorValuechange(row)">
                                </div>
                                <div *ngIf="row['label'] != 'Percentage of Ganga Grams declared ODF' && indicatorThemes['label'] !='Number of meetings held of DGC'">
                                  <input class="input-style p-0" name="comments" placeholder="" style="width: 100%;"
                                    (keypress)="allowingValuesinput($event,row)" type="text" id="#13343" autocomplete="off"
                                    [(ngModel)]="row['value']" (ngModelChange)="indicatorValuechange(row)"
                                    [min]="row['min']" [max]="row['max']" appBlockcopyPaste>
                                </div>
                                <div *ngIf="indicatorThemes['label'] == 'Number of meetings held of DGC'">
                                  <input class="input-style p-0" name="comments" placeholder="" style="width: 100%;"
                                       type="text" id="#13343" autocomplete="off" appBlockcopyPaste                                
                                      [(ngModel)]="row['value']" (ngModelChange)="indicatorValuechange(row)">
                                </div>
                              </div>
                              
                            </td>
                            <td *ngIf="row['ip'] == 'BOOLEAN' && row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional' && row['label']!='Rescue operation for endangered species have been done'">
                              <div>
                                <!-- <div>
                                      <ng-container *ngIf = "row['subindflag']">
                                          <span *ngFor = "let subinddata of row['valueData']">
                                                  <br><br>
                                                  <b>{{subinddata['value']}}</b>
                                              </span>
                                  </ng-container>
                                  </div> -->
                                <form class="d-flex justify-content-start">
                                  <input style="margin: 5px;" type="radio" name="row['sno']" value="yes"
                                    [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.Yes' | translate }}
                                  <input style="margin: 5px;" type="radio" name="row['sno']" value="no"
                                    [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.No' | translate }}
                                </form>

                              </div>
                            </td>
                            <!-- <td *ngIf="row['label']=='Rescue operation for endangered species have been done' && indicatorThemes['value']=='yes'">
                              <form class="d-flex justify-content-start">
                                <input style="margin: 5px;" type="radio" name="row['sno']" value="yes"
                                  [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.Yes--' | translate }}
                                <input style="margin: 5px;" type="radio" name="row['sno']" value="no"
                                  [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.No' | translate }}
                              </form>

                            </td> -->
                            <td style="text-align: center;"  class="form-control" *ngIf="row['isFileUpload'] == true && row['label']!='Sewerage Treatment Plants (STPs) - Non Functional' && row['label']!='Sewerage Treatment Plants (STPs) - Functional'">
                                <!-- <input id="files" type="file"  [(ngModel)]="row['excelFile']" (change)="filechoosen($event,row.entityUUID,row)" name ="file" 
                                   style=" padding:3px;" class="form-control float-right" [disabled]="row['value'] == 'no' ? true : false"> -->
                                   <!-- <ng-container *ngIf="(row['fileUUID']!=null)?displayFname(row)"></ng-container> -->
                                   <span *ngIf="row['fileUUID']!=null">{{row['isFileName']}}</span>
                                   <input id="files" type="file"  [(ngModel)]="row['excelFile']" (change)="filechoosen($event,row.entityUUID,row)" name ="file" 
                                   style=" padding:3px;" class="form-control float-right" [disabled]="row['value'] == 'no' ? true : false">
                            </td>
                            <td *ngIf="row['isFileUpload'] == true && row['fileSelected']">
                            <td *ngIf="row['fileSelected']">
                              <button class="btn btn-danger" (click)="removechosenfile(row)" type="submit">{{'submitdata.Remove' | translate}}</button>
                            </td>
                          </tr>
                          <tr *ngIf="row['label'] == 'Revenue generation activities on the Ghats' && row['value'] == 'yes'">
                            <td style="width: 50%;">d.1 {{ 'hardtable.Whether Revenue Generation is used for O&M of ghats' | translate }}</td>
                          <!-- <span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -->
                            <!-- <input class="input-style p-0" name="comments" placeholder="" style="width: 50%;"
                              type="text" id="#13343" [min]="row['min']" [max]="row['max']"> -->
                              <td>
                            <input style="margin: 5px;" id="#13343" type="radio" value="yes" [(ngModel)]="row['wrg']">{{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="#13343" type="radio" value="no" [(ngModel)]="row['wrg']">{{ 'dataSubs.No' | translate }}
                              </td>
                          <!-- </span> -->
                        
                        </tr>
                        </table>
                      </td>
                      <td *ngIf="row['label']=='Rescue operation for endangered species have been done' && indicatorThemes['value']=='yes' ">
                        <table >
                          <td style="width:50%;padding: 0 15px;">
                            {{checkSubIndicator(row['label'])?('subindlist.' + row['label'] | translate):row['label']}}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                          </td>
                          <td *ngIf="row['label']=='Rescue operation for endangered species have been done' && indicatorThemes['value']=='yes'">
                            <form class="d-flex justify-content-start">
                              <input style="margin: 5px;" type="radio" name="row['sno']" value="yes"
                                [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.Yes' | translate }}
                              <input style="margin: 5px;" type="radio" name="row['sno']" value="no"
                                [(ngModel)]="row['value']" (click)="subindicatorvaluechange(row,'boolean')"> {{ 'dataSubs.No' | translate }}
                            </form>

                          </td>

                        </table>
                      </td>
                      
                   
                    </tr>
                  </tbody>
                </table>

                <div class="row" *ngIf="indicatorLabel">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Nalla Name' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Flow Daily in MLD' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.River/Tributary into which drain is falling' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Screen Installed' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of subIndicatorList;  let i= index; let l = count;" >
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input appBlockcopyPaste autocomplete="off" id="nln_{{i}}" class="input-style p-0" [(ngModel)]="row['nln']"
                              (focusout)="focusEvent($event,row['nln'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['nln'])" [ngClass]="(status['nln_'+i]) ? 'is-invalid' : ''"
                              name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Nalla Name Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input appBlockcopyPaste autocomplete="off" id="fd_{{i}}" class="input-style p-0" [(ngModel)]="row['fd']"
                              (focusout)="focusEvent($event,row['fd'])" (keyup)="focusEvent($event,row['fd'])"(ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['fd_'+i]) ? 'is-invalid' : ''" name="comments" placeholder="" 
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Flow Daily Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input appBlockcopyPaste autocomplete="off" id="rtfall_{{i}}" class="input-style p-0" [(ngModel)]="row['rtfall']"
                              (focusout)="focusEvent($event,row['rtfall'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"(ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['rtfall'])"
                              [ngClass]="(status['rtfall_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.River/tributaries Should Not Be Empty' | translate}}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="sin_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['sin']" value="yes" (focusout)="focusEvent($event,row['sin'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['sin'])" 
                              [ngClass]="(status['sin_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="sin_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['sin']" value="no" (focusout)="focusEvent($event,row['sin'])"(ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['sin'])"
                              [ngClass]="(status['sin_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hard.Screen Installed Should Not Be Empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 220px; text-align:center;" *ngIf="row['sin'] == 'yes'">
                            <input type="file" style="width: 210px; padding:2px;" value="Browse"
                              (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                              class="form-control float-right"> -->
                            <!-- <div class="invalid-feedback">File Should Not Be Empty"</div> -->
                            <!-- <span  style="color:red;" class="pr-20" [hidden]="!row['fileselected']">Please Select File</span> -->
                          <!-- </td> -->
                          <td>
                            <div *ngIf="row['fileId']!=getCharacter(i) && row['sin'] == 'yes'; else elseBlock">
                              <label *ngIf="row['fileUUID']==null" class="form-control"  for="file_1" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="row['fileUUID']!=null" class="form-control"  for="file_1" style="cursor: pointer;">{{row['fileName']}}</label> 
                              <input id="file_1" type="file" style="height: 60px;text-align: center;width: 140px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i) && row['sin'] == 'yes'; else elsetemp">
                                  <label for="file_2" style="cursor: pointer;">{{ selectedFile }}</label>
                                  <input id="file_2" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;" *ngIf="row['sin'] == 'yes'">
                                <label for="file_3" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="file_3" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>
                          <td *ngIf="row['sin'] == 'no'">
                            <input class="input-style p-0" name="comments" placeholder="" style="width: 100%;"
                              type="text" id="#13343">
                          </td>
                          <td>
                            <span>
                              <button type="button" *ngIf="subIndicatorList.length!=1" (click)="removeSubIndTextdata(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addSubIndTextBox();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="indicatordata">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of Small River' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.No Action for rejuvenation' | translate }}</th><!--smallRiverRejuvenation[1]-->
                          <th rowspan="2">{{ 'dataSubs.Plan to rejuvenate Prepared (Yes/No)' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Rejuvenation activities undertaken' | translate }}</th>
                          <th rowspan="2">{{'dataSubs.Length of Small River Rejuvenation carried out (in km)' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of smallRiverList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="srn_{{i}}" class="input-style p-0" [(ngModel)]="row['srn']"
                              (focusout)="focusEvent($event,row['srn'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)" appBlockcopyPaste autocomplete="off"
                              (keyup)="focusEvent($event,row['srn'])" [ngClass]="(status['srn_'+i]) ? 'is-invalid' : ''"
                              name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of Small River Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="nactrjv_{{i}}" type="radio" name="{{'nactrjv_yn_'+ i}}"
                              [(ngModel)]="row['nactrjv']" value="yes" (focusout)="focusEvent($event,row['nactrjv'])" 
                              (keyup)="focusEvent($event,row['nactrjv'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['nactrjv__'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="nactrjv__{{i}}" type="radio" name="{{'nactrjv_yn_'+ i}}"
                              [(ngModel)]="row['nactrjv']" value="no" (focusout)="focusEvent($event,row['nactrjv'])"
                              (keyup)="focusEvent($event,row['nactrjv'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['nactrjv__'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.No Action for rejuvenation Should Not Be Empty' | translate}}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="ptrp_{{i}}" type="radio" name="{{'ptrp_yn_'+ i}}"
                              [(ngModel)]="row['ptrp']" value="yes" (focusout)="focusEvent($event,row['ptrp'])"
                              (keyup)="focusEvent($event,row['ptrp'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['ptrp_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="ptrp_{{i}}" type="radio" name="{{'ptrp_yn_'+ i}}"
                              [(ngModel)]="row['ptrp']" value="no" (focusout)="focusEvent($event,row['ptrp'])"
                              (keyup)="focusEvent($event,row['ptrp'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['ptrp_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Plan to rejuvenate Prepared (Yes/No) Should Not Be Empty' | translate }}
                            </div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="rau_{{i}}" type="radio" name="{{'rau_yn_'+ i}}"
                              [(ngModel)]="row['rau']" value="yes" (focusout)="focusEvent($event,row['rau'])"
                              (keyup)="focusEvent($event,row['rau'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['rau_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="rau_{{i}}" type="radio" name="{{'rau_yn_'+ i}}"
                              [(ngModel)]="row['rau']" value="no" (focusout)="focusEvent($event,row['rau'])"
                              (keyup)="focusEvent($event,row['rau'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['rau_'+i]) ? 'is-invalid' : ''">{{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Rejuvenation activities undertaken Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input class="input-style p-0" id="losrr_{{i}}" type="text" [(ngModel)]="row['losrr']" 
                            (focusout)="focusEvent($event,row['losrr'])" appDigitsOnly
                             (ngModelChange)="dynamicIndicatorsValueChanged(row)" appBlockcopyPaste autocomplete="off"
                             (keyup)="focusEvent($event,row['losrr'])" [ngClass]="(status['losrr_'+i]) ? 'is-invalid' : ''"
                             name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                          </td>
                          <!-- <td style="width: 210px; text-align: center;">
                              <input  type="file" style="width: 200px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                          </td> -->
                          <td>
                            <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock">
                              <label *ngIf="row['fileUUID']==null || row['fileUUID']=='' " class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="row['fileUUID']!=null && row['fileUUID']!=''" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{row['fileName']}}</label>
                              <input id="file_{{i}}" type="file" style="height: 60px;text-align: center;width: 140px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                  <label for="files66" style="cursor: pointer;">{{ selectedFile }}</label>
                                  <input id="files66" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;">
                                <label for="files77" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="files77" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>
                          <td>
                            <span>
                              <button type="button" *ngIf="smallRiverList.length!=1" (click)="removesmallRiverBox(i)"
                                class="btn btn-sm btn-danger mr-2 mr-2 mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addsmallriverstextBox();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="wetlandData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{'themedataObj.Name / Location of the Wetland' |translate}}</th>
                          <th rowspan="2">{{ 'dataSubs.Size of wetland (in ha)' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Activity taken up for Wetland Conservation' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of wetLandList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="wlnl_{{i}}" class="input-style p-0" [(ngModel)]="row['wlnl']"
                              (focusout)="focusEvent($event,row['wlnl'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (keyup)="focusEvent($event,row['wlnl'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['wlnl_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width:100%;" type="text" id="#13343">
                            <div class="invalid-feedback"> {{ 'hardtable.Name / Location of the Wetland Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="wlsz_{{i}}" class="input-style p-0" [(ngModel)]="row['wlsz']"
                              (focusout)="focusEvent($event,row['wlsz'])" (keyup)="focusEvent($event,row['wlsz'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['wlsz_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width:100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Size of wetland (in ha) Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="atfwlc_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['atfwlc']" value="yes" (focusout)="focusEvent($event,row['atfwlc'])"
                              (keyup)="focusEvent($event,row['atfwlc'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['atfwlc_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="atfwlc_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['atfwlc']" value="no" (focusout)="focusEvent($event,row['atfwlc'])"
                              (keyup)="focusEvent($event,row['atfwlc'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['atfwlc_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Activity taken up for Wetland Conservation Should Not Be Empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                          </td> -->
                          <td>
                            <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock">
                              <label *ngIf="row['fileUUID']==null || row['fileUUID']==''" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="row['fileUUID']!=null && row['fileUUID']!='' " class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{row['fileName']}}</label>
                              <input id="file_{{i}}" type="file" style="height: 60px;text-align: center;width: 140px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                  <label for="files66" style="cursor: pointer;">{{ selectedFile }}</label>
                                  <input id="files66" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;">
                                <label for="files77" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="files77" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>
                          <td>
                            <span>
                              <button type="button" *ngIf="wetLandList.length!=1" (click)="removewetlandTextBox(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addwetlandtextBox();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="springRejuvendData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of the Spring' | translate }} </th>
                          <th rowspan="2">{{ 'dataSubs.Activity taken up to Rejuvenate Spring' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Survey carried out to rejuvenate Spring' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of springBisunessDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="sprn_{{i}}" class="input-style p-0" [(ngModel)]="row['sprn']"
                              (focusout)="focusEvent($event,row['sprn'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (keyup)="focusEvent($event,row['sprn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['sprn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width:100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of the spring Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="atfrs_{{i}}" type="radio" name="{{'atfrs_yn_'+ i}}"
                              [(ngModel)]="row['atfrs']" value="yes" (focusout)="focusEvent($event,row['atfrs'])"
                              (keyup)="focusEvent($event,row['atfrs'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['atfrs_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="atfrs_{{i}}" type="radio" name="{{'atfrs_yn_'+ i}}"
                              [(ngModel)]="row['atfrs']" value="no" (focusout)="focusEvent($event,row['atfrs'])"
                              (keyup)="focusEvent($event,row['atfrs'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['atfrs_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Activity taken up to Rejuvenate Spring Should Not Be Empty' | translate }}
                            </div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="scors_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['scors']" value="yes" (focusout)="focusEvent($event,row['scors'])"
                              (keyup)="focusEvent($event,row['scors'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['scors_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.Yes' | translate }}
                            <input style="margin: 5px;" id="scors_{{i}}" type="radio" name="{{i}}"
                              [(ngModel)]="row['scors']" value="no" (focusout)="focusEvent($event,row['scors'])"
                              (keyup)="focusEvent($event,row['scors'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['scors_'+i]) ? 'is-invalid' : ''"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Survey carried out to rejuvenate Spring Should Not Be Empty' | translate }}
                            </div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                              </td>-->
                              <td>
                                <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock" >
                                  <label *ngIf="row['fileUUID']==null && row['fileUUID']=='' " class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                  <label *ngIf="row['fileUUID']!=null && row['fileUUID']!=''" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{row['fileName']}}</label>
                                  <input id="file_{{i}}" type="file" style="height: 60px;text-align: center;width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                                <div>
                                  <ng-template #elseBlock>
                                    <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                      <label for="files66" style="cursor: pointer;">{{ selectedFile }}</label>
                                      <input id="files66" type="file" style="width: 140px;" value="Browse"
                                        (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                        class="form-control float-right" hidden>
                                    </div>
                                  </ng-template>
                                </div >
                                <ng-template #elsetemp>
                                  <div style="height: 60px;text-align: center;">
                                    <label *ngIf="indicatorThemes['fileUUID']==null" for="files77" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                    <input id="files77" type="file" style="width: 140px;" value="Browse"
                                      (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                      class="form-control float-right" hidden>
                                  </div>
                                </ng-template>
                              </td>
                              <td *ngIf="row['fileselected'] == true">
                                <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                            </td>
                          <td> 
                            <span>
                              <button type="button" *ngIf="springBisunessDataList.length!=1"
                                (click)="removeSpringBox(i)" class="btn btn-sm btn-danger mr-2"><i
                                  class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addspringBox();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="GrossData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of Industry' | translate }} </th>
                          <th rowspan="2">{{ 'dataSubs.Sector List' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Presence of ETP (Effluent treatment Plant) in Industries' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Discharging water into local water bodies, River, Nallas and not meeting the prescribed norms' | translate }}</th>
                          <!-- <th rowspan="2">&nbsp;</th> -->
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of grossDataList; let i = index; let l = count; let p = index">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="indn_{{i}}" pattern="[a-zA-Z][a-zA-Z0-9\s]*" class="input-style p-0"
                              [(ngModel)]="row['indn']" (focusout)="focusEvent($event,row['indn'])"
                              (keyup)="focusEvent($event,row['indn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['indn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width:auto;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of Industry Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <div class="col-md-20 d-flex justify-content-start mt-8">
                              <div class="form-group mr-3">
                                <label>{{ 'dataSubs.Sector List' | translate }}</label>
                                <select id="sect_{{i}}" [(ngModel)]="row['sect']" class="form-control custom-selectbox"
                                  (focusout)="focusEvent($event,row['sect'])" (keyup)="focusEvent($event,row['sect'])"
                                  [ngClass]="(status['sect_'+i]) ? 'is-invalid' : ''" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                                  (change)="sectorChange($event.target.value)">
                                  <option value="" [disabled]="true">{{'dataSubs.Select Sector' | translate}}</option>
                                  <option *ngFor="let sector of sectorList |keyvalue" value="{{sector['key']}}">
                                    {{'dataSubs.' + sector['value'] | translate}}</option>
                                </select>
                              </div>
                            </div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="etpp_{{i}}" type="radio" name="{{'etpp_yn_'+ i}}"
                              [(ngModel)]="row['etpp']" (focusout)="focusEvent($event,row['etpp'])"
                              (keyup)="focusEvent($event,row['etpp'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['etpp_'+i]) ? 'is-invalid' : ''" value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="etpp_{{i}}" type="radio" name="{{'etpp_yn_'+ i}}"
                              [(ngModel)]="row['etpp']" (focusout)="focusEvent($event,row['etpp'])"
                              (keyup)="focusEvent($event,row['etpp'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['etpp_'+i]) ? 'is-invalid' : ''" value="no"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Presence of ETP should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="dcw_{{i}}" type="radio" name="{{'dcw_yn_'+ i}}"
                              [(ngModel)]="row['dcw']" (focusout)="focusEvent($event,row['dcw'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['dcw'])" [ngClass]="(status['dcw_'+i]) ? 'is-invalid' : ''"
                              value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="dcw_{{i}}" type="radio" name="{{'dcw_yn_'+ i}}"
                              [(ngModel)]="row['dcw']" (focusout)="focusEvent($event,row['dcw'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['dcw'])" [ngClass]="(status['dcw_'+i]) ? 'is-invalid' : ''"
                              value="no"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Discharging water should not be empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                              </td> -->
                          <td>
                            <span>
                              <button type="button" *ngIf="grossDataList.length!=1" (click)="removeGrossData(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addGrossDataBox();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="industryData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of Industry' | translate}}</th>
                          <th rowspan="2">{{ 'dataSubs.No Action' | translate}}</th>
                          <th rowspan="2">{{ 'dataSubs.Notice Issued u/s 5 of EPA' | translate}}</th>
                          <th rowspan="2">{{ 'dataSubs.Industry has become compliant' | translate}}</th>
                          <th rowspan="2">{{ 'dataSubs.Industry closure' | translate}}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of industryDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="indn_{{i}}" class="input-style p-0" [(ngModel)]="row['indn']"
                              (focusout)="focusEvent($event,row['indn'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (keyup)="focusEvent($event,row['indn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['indn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width:100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of Industry Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="nact_{{i}}" type="radio" name="{{'nact_yn_'+ i}}"
                              [(ngModel)]="row['nact']" (focusout)="focusEvent($event,row['nact'])"
                              (keyup)="focusEvent($event,row['nact'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['nact_'+i]) ? 'is-invalid' : ''" value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="nact_{{i}}" type="radio" name="{{'nact_yn_'+ i}}"
                              [(ngModel)]="row['nact']" (focusout)="focusEvent($event,row['nact'])"
                              (keyup)="focusEvent($event,row['nact'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['nact_'+i]) ? 'is-invalid' : ''" value="no"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.No Action should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="epani_{{i}}" type="radio" name="{{'epani_yn_'+ i}}"
                              [(ngModel)]="row['epani']" (focusout)="focusEvent($event,row['epani'])"
                              (keyup)="focusEvent($event,row['epani'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['epani_'+i]) ? 'is-invalid' : ''" value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="epani_{{i}}" type="radio" name="{{'epani_yn_'+ i}}"
                              [(ngModel)]="row['epani']" (focusout)="focusEvent($event,row['epani'])"
                              (keyup)="focusEvent($event,row['epani'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['epani_'+i]) ? 'is-invalid' : ''" value="no"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback"> {{ 'hardtable.Notice Issued u/s 5 of EPA should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="ihbc_{{i}}" type="radio" name="{{'ihbc_yn_'+ i}}"
                              [(ngModel)]="row['ihbc']" (focusout)="focusEvent($event,row['ihbc'])"
                              (keyup)="focusEvent($event,row['ihbc'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['ihbc_'+i]) ? 'is-invalid' : ''" value="yes"
                              [disabled]="row['indclsr'] ?'true':'false'" > {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="ihbc_{{i}}" type="radio" name="{{'ihbc_yn_'+ i}}"
                              [(ngModel)]="row['ihbc']" (focusout)="focusEvent($event,row['ihbc'])"
                              (keyup)="focusEvent($event,row['ihbc'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['ihbc_'+i]) ? 'is-invalid' : ''" value="no"
                              [disabled]="row['indclsr'] ?'true':'false'"> {{ 'dataSubs.No' | translate }}
                            <div [hidden]="row['indclsr']" class="invalid-feedback">"Industry has become compliant or Industry closure should not be empty"</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="indclsr_{{i}}" type="radio" name="{{'indclsr_yn_'+ i}}"
                              [(ngModel)]="row['indclsr']" (focusout)="focusEvent($event,row['indclsr'])"
                              (keyup)="focusEvent($event,row['indclsr'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['indclsr_'+i]) ? 'is-invalid' : ''" value="yes"
                              [disabled]="row['ihbc'] ?'true':'false'"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="indclsr_{{i}}" type="radio" name="{{'indclsr_yn_'+ i}}"
                              [(ngModel)]="row['indclsr']" (focusout)="focusEvent($event,row['indclsr'])"
                              (keyup)="focusEvent($event,row['indclsr'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['indclsr_'+i]) ? 'is-invalid' : ''" value="no"
                              [disabled]="row['ihbc'] ?'true':'false'"> {{ 'dataSubs.No' | translate }}
                            <div [hidden]="row['ihbc']" class="invalid-feedback">{{'hardtable.Industry has become compliant or Industry closure should not be empty' | translate }}</div>
                          </td>
                          <td >
                            <!-- <input type="file" style="width: 140px;" value="Browse"
                              (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                              class="form-control float-right">  -->
                              <!-- <input type="file" style="width: 110px; padding:3px;" value="Browse"
                              (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                              class="form-control float-right">-->
                              

                            <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock" >
                              <label *ngIf="row['fileUUID']==null || row['fileUUID']=='' " class="form-control"  for="files4" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="row['fileUUID']!=null && row['fileUUID']!=''" class="form-control"  for="files4" style="cursor: pointer;">{{row['fileName']}}</label>
                              <input id="files4" type="file" style="height: 60px;text-align: center;width: 140px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                  <label for="files44" style="cursor: pointer;">{{ selectedFile }}</label>
                                  <input id="files44" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <!-- <td style="width: 120px; text-align: center;">
                              <input id="file_{{i}}" type="file" style="width: 110px; padding:3px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right">
                            </td>td> -->

                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;">
                                <label for="files55" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="files55" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>

                            <!-- <div class="invalid-feedback">File Should Not Be Empty"</div> -->
                            <!-- <span  style="color:red;" class="pr-20" [hidden]="!row['fileselected']">Please Select File</span> -->
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>

                          <td>
                            <span>
                              <button type="button" *ngIf="industryDataList.length!=1" (click)="removeindustryData(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addindustryData();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="nallaData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th translate rowspan="2">{{'dataSubs.Nallas Name' | translate}}</th>
                          <th rowspan="2">{{'dataSubs.Tapping Done' | translate}} </th>
                          <th rowspan="2">{{ 'dataSubs.If No - Covered under Bioremediation' | translate}}</th>
                          <!-- <th rowspan="2">&nbsp;</th> -->
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of nallaDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="nln_{{i}}" class="input-style p-0" [(ngModel)]="row['nln']"
                              (focusout)="focusEvent($event,row['nln'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['nln'])" [ngClass]="(status['nln_'+i]) ? 'is-invalid' : ''"
                              name="comments" placeholder="" style="width:100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Nallas Name should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="td_{{i}}" type="radio" name="{{'td_yn_'+ i}}"
                              [(ngModel)]="row['td']" (focusout)="focusEvent($event,row['td'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['td'])" [ngClass]="(status['td_'+i]) ? 'is-invalid' : ''"
                              value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="td_{{i}}" type="radio" name="{{'td_yn_'+ i}}"
                              [(ngModel)]="row['td']" (focusout)="focusEvent($event,row['td'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              (keyup)="focusEvent($event,row['td'])" [ngClass]="(status['td_'+i]) ? 'is-invalid' : ''"
                              value="no"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Tapping Done should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input style="margin: 5px;" id="cubrn_{{i}}" type="radio" name="{{'cubrn_yn_'+ i}}"
                              [(ngModel)]="row['cubrn']" (focusout)="focusEvent($event,row['cubrn'])"
                              (keyup)="focusEvent($event,row['cubrn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['cubrn_'+i]) ? 'is-invalid' : ''" value="yes"
                              [disabled]="row['td']=='no'? false : true"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" id="cubrn_{{i}}" type="radio" name="{{'cubrn_yn_'+ i}}"
                              [(ngModel)]="row['cubrn'] " (focusout)="focusEvent($event,row['cubrn'])"
                              (keyup)="focusEvent($event,row['cubrn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['cubrn_'+i]) ? 'is-invalid' : ''" value="no"
                              [disabled]="row['td']=='no'? false : true"> {{ 'dataSubs.No' | translate }}
                            <div class="invalid-feedback">{{ 'hardtable.Covered under Bioremediation should not be empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input  type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                              </td> -->
                          <td>
                            <span>
                              <button type="button" *ngIf="nallaDataList.length!=1" (click)="removenallaData(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addnallaData();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div *ngIf="stpData && stpboolean">{{ 'IndiAndSubindList.Sewerage Treatment Plants (STPs) - Non Functional' | translate }}</div>
                <div class="row" *ngIf="stpData && stpboolean">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'hardtable.Name of STP' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.No Action' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.DPR Prepared' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Project Approved' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under Tendering' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under Rehabilitation' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under O&M' | translate }}</th>
                          <!-- <th rowspan="2">&nbsp;</th> -->
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of stpBooleanDatalist; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['stpn']" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['nact']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['dprp']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['pa']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['ut']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['urn']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['uom']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <!-- <td> -->
                          <!-- <td style="width: 120px; text-align: center;">
                                <input id="file_{{i}}" type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" appDigitsOnly>
                                </td> -->
                          <td>
                            <span>
                              <button type="button" *ngIf="stpyesdatalist.length!=1" (click)="removeStpyesformat(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addStpDatayes()"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div *ngIf="stpData && stpDatavalue">{{ 'IndiAndSubindList.Sewerage Treatment Plants (STPs) - Functional' | translate }}</div>
                <div class="row" *ngIf="stpData && stpDatavalue">
                <!-- <div *ngIf="indicatorThemes['value']=='yes' && stpData">Sewerage Treatment Plants (STPs) -Functional</div>
                <div class="row" *ngIf="indicatorThemes['value']=='yes' && stpData"> -->
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of STP' | translate}}</th>
                          <th rowspan="2">{{ 'hardtable.Capacity of STP (MLD)' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Current Utilisation of STP Capacity (MLD)' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Meeting Design Standard (Yes/No)' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Data Captured in Ganga Monitoring Center (Yes/No)' | translate }}</th>
                          <th rowspan="2">.%{{ 'hardtable.capacity of STP utilised' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of stpdataformat; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['stpn']" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['stpc']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)" autocomplete="off"
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['custpc']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)" autocomplete="off"
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                          </td>
                          <td>
                            <input style="margin: 5px;" type="radio" name="{{'mds_yn_'+ i}}" [(ngModel)]="row['mds']"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" type="radio" name="{{'mds_yn_'+ i}}" [(ngModel)]="row['mds']"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              value="no"> {{ 'dataSubs.No' | translate }}
                          </td>
                          <td>
                            <input style="margin: 5px;" type="radio" name="{{'dcgmc_yn_'+ i}}"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [(ngModel)]="row['dcgmc']" value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" type="radio" name="{{'dcgmc_yn_'+ i}}"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [(ngModel)]="row['dcgmc']" value="no"> {{ 'dataSubs.No' | translate }}
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['pcstpu']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)" autocomplete="off"
                              style="width: 100%;" type="text" id="#13343" appFloatwithMinmax max="100">
                          </td>
                          <td>
                            <!-- <td style="width: 210px; text-align: center;"> -->
                            <!-- <input id="file_{{i}}" type="file" style="width: 200px; padding:3px;" value="Browse"
                            (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                              class="form-control float-right">
                            <div class="invalid-feedback">File Should Not Be Empty"</div>
                            <span  style="color:red;" class="pr-20" [hidden]="!row['fileselected']">Please Select File</span> -->
                            <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock" >
                              <label *ngIf="indicatorThemes['fileUUID']==null" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="indicatorThemes['fileUUID']!=null" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{indicatorThemes['fileName']}}</label>
                              <input id="file_{{i}}" type="file" style="height: 60px;text-align: center;width: 110px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                  <label for="files66" style="cursor: pointer;">{{ selectedFile[i] }}</label>
                                  <input id="files66" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;">
                                <label for="files77" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="files77" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>
                          <td>
                            <span>
                              <button type="button" *ngIf="stpdataformat.length!=1" (click)="removedataformat(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addstpdataformat();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div *ngIf="stpData && stpDatavalue2">{{ 'IndiAndSubindList.Sewerage Treatment Plants (STPs) - Functional' | translate }}</div>
                <div class="row" *ngIf="stpData && stpDatavalue2">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of STP' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.No Action' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.DPR Prepared' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Project Approved' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under Tendering' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under Rehabilitation' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Under O&M' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                          <!-- <th rowspan="2">&nbsp;</th> -->
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of stpdatavalueformat; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['stpn']" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              name="comments" placeholder="" style="width: 100%;" type="text" id="#13343">
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['stpc']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['custpc']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <td>
                            <input style="margin: 5px;" type="radio" name="{{'mds_yn_'+ i}}" [(ngModel)]="row['mds']"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" type="radio" name="{{'mds_yn_'+ i}}" [(ngModel)]="row['mds']"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              value="no"> {{ 'dataSubs.No' | translate }}
                          </td>
                          <td>
                            <input style="margin: 5px;" type="radio" name="{{'dcgmc_yn_'+ i}}" [(ngModel)]="row['dcgmc']"
                             (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                               value="yes"> {{ 'dataSubs.Yes' | translate }} <br>
                            <input style="margin: 5px;" type="radio" name="{{'dcgmc_yn_'+ i}}"
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [(ngModel)]="row['dcgmc']" value="no"> {{ 'dataSubs.No' | translate }}
                          </td>
                          <td>
                            <input class="input-style p-0" [(ngModel)]="row['pcstpu']" name="comments" placeholder=""
                            (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              style="width: 100%;" type="text" id="#13343" appDigitsOnly>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                            <input id="file_{{i}}" type="file" style="width: 110px; padding:3px;" value="Browse"
                              (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                              class="form-control float-right"> -->
                            <!-- <div class="invalid-feedback">File Should Not Be Empty"</div> -->
                            <!-- <span  style="color:red;" class="pr-20" [hidden]="!row['fileselected']">Please Select File</span> -->
                          <!-- </td> -->
                          <td>
                            <div *ngIf="row['fileId']!=getCharacter(i);else elseBlock" > 
                              <label *ngIf="indicatorThemes['fileUUID']==null" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                              <label *ngIf="indicatorThemes['fileUUID']!=null" class="form-control"  for="file_{{i}}" style="cursor: pointer;">{{indicatorThemes['fileName']}}</label>
                              <input id="file_{{i}}" type="file" style="height: 60px;text-align: center;width: 110px;" value="Browse"
                                (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                class="form-control float-right" hidden>
                            </div>
                            <div>
                              <ng-template #elseBlock>
                                <div class="form-control " *ngIf="row['fileId'] ==  getCharacter(i); else elsetemp">
                                  <label for="files66" style="cursor: pointer;">{{ selectedFile[i] }}</label>
                                  <input id="files66" type="file" style="width: 140px;" value="Browse"
                                    (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                    class="form-control float-right" hidden>
                                </div>
                              </ng-template>
                            </div >
                            <ng-template #elsetemp>
                              <div style="height: 60px;text-align: center;">
                                <label for="files77" class="form-control" style="cursor: pointer;height: 60px;">{{'submitdata.uploadsupportdoc' | translate}}</label>
                                <input id="files77" type="file" style="width: 140px;" value="Browse"
                                  (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right" hidden>
                              </div>
                            </ng-template>
                          </td>
                          <td *ngIf="row['fileselected'] == true">
                            <button class="btn btn-danger" (click)="removefilerecord(row)"  type="submit">{{ 'submitdata.Remove' | translate}}</button>
                          </td>
                          <td>
                            <!-- <span>
                              <button type="button" *ngIf="stpdatavalueformat.length!=1" (click)="removestpvalue(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addstpvalueformat();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span> -->
                            <span>
                              <button type="button" *ngIf="stpdatavalueformat.length!=1" (click)="removestpvalue(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addstpvalueformat();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="stpPercentageData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of STP' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Fund Allocated for its Construction' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Amount spent inconstruction' | translate }}</th>
                          <!-- <th rowspan="2">&nbsp;</th> -->
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of stpPercentageDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="stpn_{{i}}" class="input-style p-0" [(ngModel)]="row['stpn']"
                              pattern="[a-zA-Z][a-zA-Z0-9\s]*" (focusout)="focusEvent($event,row['stpn'])"
                              (keyup)="focusEvent($event,row['stpn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['stpn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of STP should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="flfc_{{i}}" class="input-style p-0" [(ngModel)]="row['flfc']"
                              (focusout)="focusEvent($event,row['flfc'])" (keyup)="focusEvent($event,row['flfc'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['flfc_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Fund Allocated for its Construction should not be empty' | translate }}
                            </div>
                          </td>
                          <td>
                            <input id="asic_{{i}}" class="input-style p-0" [(ngModel)]="row['asic']"
                              (focusout)="focusEvent($event,row['asic'])" (keyup)="focusEvent($event,row['asic'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['asic_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Amount spent inconstruction should not be empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input  type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                              </td> -->
                          <td>
                            <span>
                              <button type="button" *ngIf="stpPercentageDataList.length!=1" (click)="removestpdata(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addstpdata();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <p *ngIf="reusageWaterData && indicatorThemes['value'] == 'yes'">{{ 'hardtable.Uses In % for Different Purposes' | translate }} </p>
                <div class="row" *ngIf="reusageWaterData">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'dataSubs.Name of STP' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Current Utilisation of STP Capacity (MLD)' | translate }} </th>
                          <th rowspan="2">{{ 'dataSubs.Total reused (in MLD)' | translate }} </th>
                          <th rowspan="2">{{ 'dataSubs.Commercial' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Construction' | translate }} </th>
                          <th rowspan="2">{{ 'dataSubs.Agricultural' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Gardening' | translate }}</th>
                          <th rowspan="2">{{ 'dataSubs.Other Non - potable' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of waterReusedDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="stpn_{{i}}" class="input-style p-0" [(ngModel)]="row['stpn']"
                              (focusout)="focusEvent($event,row['stpn'])" pattern="[a-zA-Z][a-zA-Z0-9\s]*"
                              (keyup)="focusEvent($event,row['stpn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['stpn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{ 'hardtable.Name of STP should not be empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="custpc_{{i}}" class="input-style p-0" [(ngModel)]="row['custpc']"
                              (focusout)="focusEvent($event,row['custpc'])" (keyup)="focusEvent($event,row['custpc'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['custpc_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Current Utilisation of STP Capacity should not be empty' | translate }}
                            </div>
                          </td>
                          <td>
                            <input id="tr_{{i}}" class="input-style p-0" [(ngModel)]="row['tr']"
                              (focusout)="focusEvent($event,row['tr'])" (keyup)="focusEvent($event,row['tr'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['tr_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Total reused (in MLD)' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="cmrcl_{{i}}" class="input-style p-0" [(ngModel)]="row['cmrcl']"
                              (focusout)="focusEvent($event,row['cmrcl'])" (keyup)="focusEvent($event,row['cmrcl'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['cmrcl_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Commercial' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="cnsrn_{{i}}" class="input-style p-0" [(ngModel)]="row['cnsrn']"
                              (focusout)="focusEvent($event,row['cnsrn'])" (keyup)="focusEvent($event,row['cnsrn'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['cnsrn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Construction' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="agcl_{{i}}" class="input-style p-0" [(ngModel)]="row['agcl']"
                              (focusout)="focusEvent($event,row['agcl'])" (keyup)="focusEvent($event,row['agcl'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['agcl_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Agricultural' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="grdng_{{i}}" class="input-style p-0" [(ngModel)]="row['grdng']"
                              (focusout)="focusEvent($event,row['grdng'])" (keyup)="focusEvent($event,row['grdng'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['grdng_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Gardening' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="onp_{{i}}" class="input-style p-0" [(ngModel)]="row['onp']"
                              (focusout)="focusEvent($event,row['onp'])" (keyup)="focusEvent($event,row['onp'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['onp_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'dataSubs.Other Non - potable' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <!-- <td style="width: 120px; text-align: center;">
                              <input  type="file" style="width: 110px; padding:3px;" value="Browse" (change)="fileChoosen($event,getCharacter(i),row)" name="Browse"
                                  class="form-control float-right">
                              </td>
                            <td> -->
                          <td>
                            <span>
                              <button type="button" *ngIf="waterReusedDataList.length!=1" (click)="removeWaterData(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addWaterData();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row" *ngIf="planlabel && indicatorThemes['value'] == 'yes'">
                  <div class="col-md-12 col-lg-12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th rowspan="2">&nbsp;</th>
                          <th rowspan="2">{{ 'hardtable.Name of FSTP' | translate }}</th>
                          <th rowspan="2">{{ 'hardtable.Capacity (kLD)' | translate }}</th>
                          <th rowspan="2">&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody class="text-white">
                        <tr *ngFor="let row of planDataList; let i = index; let l = count;">
                          <td>{{getCharacter(i)}}</td>
                          <td>
                            <input id="stpn_{{i}}" class="input-style p-0" [(ngModel)]="row['stpn']"
                              pattern="[a-zA-Z][a-zA-Z0-9\s]*" (focusout)="focusEvent($event,row['stpn'])"
                              (keyup)="focusEvent($event,row['stpn'])" (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['stpn_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343">
                            <div class="invalid-feedback">{{'hardtable.Name of FSTP' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <input id="stpc_{{i}}" class="input-style p-0" [(ngModel)]="row['stpc']"
                              (focusout)="focusEvent($event,row['stpc'])" (keyup)="focusEvent($event,row['stpc'])"
                              (ngModelChange)="dynamicIndicatorsValueChanged(row)"
                              [ngClass]="(status['stpc_'+i]) ? 'is-invalid' : ''" name="comments" placeholder=""
                              style="width: 100%;" type="text" id="#13343" appTwoDigitDecimalNumber>
                            <div class="invalid-feedback">{{ 'hardtable.Capacity (kLD)' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                          </td>
                          <td>
                            <span>
                              <button type="button" *ngIf="planDataList.length!=1" (click)="removeplanData(i)"
                                class="btn btn-sm btn-danger mr-2"><i class="fa fa-minus"></i></button>
                              <button type="button" *ngIf="i== l-1" (click)="addplanData();"
                                class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>

                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div [hidden]="meetingflag" *ngIf="meetingSendData">
                  <div class="col-12">
                    <div class="d-flex ">
                      <h4>{{'submitdata.dgcmeeting' | translate }} </h4>
                    </div>
                    <hr style="margin: 0px;" class="my-1" />

                    <div class="d-flex">

                      <div class=" flex-column w-50">
                        <h5>{{'submitdata.Topics of the meeting' | translate }}<span class="text-star">*</span></h5>
                        <ng-multiselect-dropdown [placeholder]="'select topics'" [data]="meetingDataList" 
                        class="text-white" [(ngModel)]="customFilter['cat']" style="height:40px"
                        [settings]="dropdownSettings" (onSelect)="onItemSelects($event)"
                        (onSelectAll)="onSelectAlls($event)" (onDeSelect)="onItemDeSelects($event)" 
                        (onDeSelectAll)="onItemDeSelectAlls($event)">
                        </ng-multiselect-dropdown>

                      </div>&nbsp;
                      <div class=" flex-column w-50" *ngIf = "showtextBox">
                        <h5>{{'submitdata.description' | translate }}:</h5>
                        <div>
                          <input  [(ngModel)]="selecteditemobj"
                            name="comments" placeholder=""
                          style="width: 100%;height: 40px;" type="text" id="#13343">
                          </div>
                      </div>
                      <!-- <div >
                        <h5 class="">{{'submitdata.dateofmeeting' | translate }}</h5>
                        <app-custom-datepicker (change)="datepickermodel($event)" class="calendar" placeholder="From"
                        [(minDate)]="minDate" [(maxDate)]="maxDate" [(calendarFormat)]="dateformat['value']"
                        [(ngModel)]="attendanceFilter['startdate']" ngDefaultControl></app-custom-datepicker>
                        <div class="input-group input-group-sm">
                        <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"> 
                          <input  [(ngModel)]="attendanceFilter['startdate']" readonly  (click)="sd.toggle()" id="date1" aria-label="Recipient's username" aria-describedby="basic-addon2" class="form-control datepicke pl-3"  name="date1" placeholder="Select Date" ngbDatepicker #sd="ngbDatepicker" (ngModelChange)="datepickermodelforstart($event)">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary" (click)="sd.toggle()" type="button"><i class="fas fa-calendar"></i></button>
                          </div>
                        </div>
                      </div> -->
                      <div class="d-flex flex-column w-50 pl-2" *ngIf="showinputButton">
                        <h5 for="">{{'submitdata.dateofmeeting' | translate }}<span class="text-star">*</span></h5>
                        <div class="input-group input-group-sm">
                          <!-- <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
                          <input  [(ngModel)]="selectedDate" readonly  (click)="sd.toggle();changeMonth($event.target.value)" style="height: 40px;"
                          id="date1" aria-label="Recipient's username" aria-describedby="basic-addon2" 
                          class="form-control datepicke pl-3" name="date1" placeholder="{{selectedDate}}"
                           ngbDatepicker #sd="ngbDatepicker"  [(minDate)]="minDate" [(maxDate)]="maxDate" (ngModelChange)="changeStartDate($event)">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary" (click)="sd.toggle()" type="button"><i class="fas fa-calendar"></i></button>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column w-50 pl-2" *ngIf="!showinputButton">
                        <h5 for="">{{'submitdata.dateofmeeting' | translate }}<span class="text-star">*</span></h5>
                        <div class="input-group input-group-sm">
                          <!-- <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="basic-addon2"> -->
                          <input  [(ngModel)]="selectedDate" readonly  (click)="sd.toggle()" style="height: 40px;"
                          id="date1" aria-label="Recipient's username" aria-describedby="basic-addon2" 
                          class="form-control datepicke pl-3" name="date1" placeholder="{{'dataSubs.Select Date' | translate}}"
                           ngbDatepicker #sd="ngbDatepicker"  [(minDate)]="minDate" [(maxDate)]="maxDate" (ngModelChange)="changeStartDate($event)">
                          <div class="input-group-append">
                            <button class="btn btn-outline-secondary" (click)="sd.toggle()" type="button"><i class="fas fa-calendar"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr style="margin: 0px;" class="my-1" />
                    <div class="d-flex flex-column" *ngIf = "!showtabledata">
                      <h5>{{'submitdata.attendance' | translate }}</h5>
                      <div style="overflow-x:scroll">
                        <table class="table" style="width:100%">
                          <thead>
                            <tr>
                              <th scope="col">{{'submitdata.slno' | translate }}</th>
                              <th style="min-width:250px" scope="col">{{'submitdata.officials' | translate }}</th>
                              <th style="min-width:250px" scope="col">{{'submitdata.name' | translate }}</th>
                              <th scope="col">{{'submitdata.designation' | translate }}</th>
                              <th style="min-width:180px" scope="col">{{'submitdata.mobile' | translate }}</th>
                              <th style="min-width:280px" scope="col">{{'submitdata.emailid' | translate }}</th>
                              <th scope="col">{{'submitdata.gender' | translate }}</th>
                              <th scope="col">{{'submitdata.attendance' | translate }}</th>
                              <!-- <th scope="col">{{'submitdata.addmore' | translate }}</th> -->

                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let tabledata of attendanceTableRawData; let i =index">
                              <td>{{i+1}}</td>
                              <td>
                                <input   style="width: 150px;" class="input-style p-0" [(ngModel)]="tabledata['officials']" name="comments" placeholder=""
                                  style="width: 100%;" type="text" id="#13343"
                                  [disabled]="tabledata['officials'] == 'District Collector' || tabledata['officials']=='Representative from municipalities' || tabledata['officials']=='Representative from gram panchayats' 
                                  || tabledata['officials']=='Representative from Public Works' || tabledata['officials']=='Representative from Irrigation' || tabledata['officials']=='Representative from Public Health Engineering' || tabledata['officials']=='Representative from Rural Drinking Water Department'
                                  || tabledata['officials']=='Representative from State Pollution Control Board' || tabledata['officials']=='District official to be nominated by DC' || tabledata['officials']=='Divisional Forest Officer' || tabledata['officials']=='Environmentalists associated with River Ganga protection' 
                                  || tabledata['officials']=='Representative of local industry' ? true : false" >
                              </td>        
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <input onkeydown="return /[a-z, ]/i.test(event.key)"  style="width: 150px;" class="input-style p-0" [(ngModel)]="tabledata['post']" name="comments" placeholder=""
                                  style="width: 100%;" type="text" id="#13343">
                              </td>

                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'"></span>
                                <input onkeydown="return /[a-z, ]/i.test(event.key)" (keypress)="restrictCommas($event)" minlength=2 maxlength=35
                                 style="width: 150px;" class="input-style p-0" [(ngModel)]="tabledata['name']" name="comments" placeholder=""
                                  style="width: 100%;" type="text" id="#13343">
                              </td>
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <input appBlockcopyPaste (keypress)="keyPress($event)" (change)="validateContact(tabledata['contactno'])"
                                 minlength=10 maxlength=10  title="Please enter exactly 10 digits" style="width: 150px;"
                                  class="input-style p-0" [(ngModel)]="tabledata['contactno']" name="comments" placeholder=""
                                  style="width: 100%;" type="text" id="#13343">
                              </td>
                              <td>
                                <div class="form-group">
                                  <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                  <input  name = "email" autocomplete="off" [(ngModel)] = "tabledata['emailid']" (change)="validateEmail(tabledata['emailid'])" type="text" class="form-control">
                                  <!-- <span class="help-block" *ngIf = "email.errors ?.required && email.touched">Email is Required</span>
                                  <span class="help-block" *ngIf = "email.errors ?.email && email.touched">Email is Invalid</span> -->
                                </div>
                                <!-- <input id="contactemail" type="text" #contactemail="ngModel" [(ngModel)]="tabledata['emailid']" required
                                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                                  <div class="md-errors-spacer" [hidden]="contactemail.valid || contactemail.untouched">
                                    <div  *ngIf="contactemail.errors && contactemail.errors.required">
                                        Email is required
                                    </div>
                                    <div  *ngIf="contactemail.errors && contactemail.errors.pattern">
                                        Email is invalid
                                    </div>
                                </div> -->
                              </td>
                              <td>
                                <select style="width: 150px;"  class="form-control custom-selectbox" [(ngModel)]="tabledata['gender']" >
                                  <option value="" [disabled]="true">Select Gender</option>
                                  <option *ngFor="let item of genderList |keyvalue "
                                  value="{{item['key']}}">{{item['value']}}</option>
                                </select>
                              </td>
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <select style="width: 150px;"  class="form-control custom-selectbox" [(ngModel)]="tabledata['attendance']" >
                                  <option value="" [disabled]="true">Select Attendance</option>
                                  <option *ngFor="let item of attendanceList |keyvalue "
                                  value="{{item['key']}}">{{item['value']}}</option>
                                </select>
                              </td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                    </div>
                    <div class="d-flex flex-column" *ngIf = "showtabledata">
                      <h5>{{'submitdata.attendance' | translate }}</h5>
                      <div style="overflow-x:scroll">
                        <table class="table" style="width:100%">
                          <thead>
                            <tr>
                              <th scope="col">{{'submitdata.slno' | translate }}</th>
                              <th style="min-width:431px" scope="col">{{'submitdata.officials' | translate }}</th>
                              <th style="min-width:250px" scope="col">{{'submitdata.name' | translate }}</th>
                              <th scope="col" style="min-width:165px">{{'submitdata.designation' | translate }}</th>
                              <th style="min-width:112px" scope="col">{{'submitdata.mobile' | translate }}</th>
                              <th style="min-width:250px" scope="col">{{'submitdata.emailid' | translate }}</th>
                              <th scope="col">{{'submitdata.gender' | translate }}</th>
                              <th scope="col">{{'submitdata.attendance' | translate }}</th>

                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let tabledata of tabledataFormat; let i =index" >
                              <td>{{i+1}}</td>
                              <td >
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'"></span>
                                <input autocomplete="off"  style="width: 150px;" class="input-style p-0" [(ngModel)]="tabledata['officials']"
                                 name="comments" placeholder="" (ngModelChange)="checkAllFieldsChanged(tabledata)" 
                                 [disabled]="tabledata['officials'] == 'District Collector' || tabledata['officials']=='Representative from municipalities' || tabledata['officials']=='Representative from gram panchayats' 
                                  || tabledata['officials']=='Representative from Public Works' || tabledata['officials']=='Representative from Irrigation' || tabledata['officials']=='Representative from Public Health Engineering' || tabledata['officials']=='Representative from Rural Drinking Water Department'
                                  || tabledata['officials']=='Representative from State Pollution Control Board' || tabledata['officials']=='District official to be nominated by DC' || tabledata['officials']=='Divisional Forest Officer' || tabledata['officials']=='Environmentalists associated with River Ganga protection' 
                                  || tabledata['officials']=='Representative of local industry' ? true : false"
                                  style="width: 100%;" type="text" id="#13343">
                              </td>    
                              <!-- [disabled]="tabledata['officials'] == 'Divisional Forest Officer'?true:false"      -->
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <input autocomplete="off" id="post_{{i}}" onkeydown="return /[a-z, ]/i.test(event.key)" style="width: 150px;"
                                (focusout)="focusEvent($event,tabledata['post'])" (keyup)="focusEvent($event,tabledata['post'])"
                                 class="input-style p-0" [(ngModel)]="tabledata['post']" name="comments" placeholder=""
                                 (ngModelChange)="checkAllFieldsChanged(tabledata,i)" [ngClass]="(status['post_'+i]) ? 'is-invalid' : ''"
                                  style="width: 100%;" type="text" id="#13343">
                                  <div class="invalid-feedback">{{'submitdata.name' | translate }} {{ 'hardtable.Should Not Be Empty' | translate }}</div>
                              </td>
                              
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'"></span>
                                <input autocomplete="off" id="name_{{i}}" onkeydown="return /[a-z -]/i.test(event.key)" minlength="2" 
                                (focusout)="focusEvent($event,tabledata['name'])" (keyup)="focusEvent($event,tabledata['name'])"
                                maxlength="35"  style="width: 150px;" class="input-style p-0" [(ngModel)]="tabledata['name']"
                                 name="comments" placeholder="" (ngModelChange)="checkAllFieldsChanged(tabledata)"
                                 [ngClass]="(status['name_'+i]) ? 'is-invalid' : ''"
                                  style="width: 100%;" type="text" id="#13343">
                                  <div class="invalid-feedback">{{'submitdata.designation' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                              </td>
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <input appBlockcopyPaste autocomplete="off" id="contactno_{{i}}" (keypress)="keyPress($event)" required 
                                (keypress)="validateContact(tabledata['contactno'])" maxlength=10 
                                (focusout)="focusEvent($event,tabledata['contactno'])" (keyup)="focusEvent($event,tabledata['contactno'])"
                                 title="Please enter exactly 10 digits" style="width: 150px;" class="input-style p-0" 
                                 [(ngModel)]="tabledata['contactno']" name="comments" placeholder="" style="width: 100%;"
                                 [ngClass]="(status['contactno_'+i]) ? 'is-invalid' : ''"
                                 (ngModelChange)="checkAllFieldsChanged(tabledata)" type="text" id="#13343">
                                 <div class="invalid-feedback">{{'submitdata.mobile' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                              </td>
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <div class="form-group">
                                  <input autocomplete="off" name = "email" #email = "ngModel" id="emailid_{{i}}" [(ngModel)] = "tabledata['emailid']" 
                                  (focusout)="focusEvent($event,tabledata['emailid'])" (keyup)="focusEvent($event,tabledata['emailid'])"
                                  (change)="validateEmail(tabledata['emailid'])" type="text" class="form-control"
                                  (ngModelChange)="checkAllFieldsChanged(tabledata)" [ngClass]="(status['emailid_'+i]) ? 'is-invalid' : ''">
                                  <div class="invalid-feedback">{{'submitdata.emailid' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                                  <!-- <span class="help-block" *ngIf = "email.errors ?.required && email.touched">Email is Required</span>
                                  <span class="help-block" *ngIf = "email.errors ?.email && email.touched">Email is Invalid</span> -->
                                </div>
                              </td>
                              <td>
                                <select style="width: 150px;" id="gender_{{i}}" class="form-control custom-selectbox" [(ngModel)]="tabledata['gender']"
                                (ngModelChange)="checkAllFieldsChanged(tabledata)" [ngClass]="(status['gender_'+i]) ? 'is-invalid' : ''"
                                (focusout)="focusEvent($event,tabledata['gender'])" (keyup)="focusEvent($event,tabledata['gender'])" >
                                  <option value="">{{ 'dataSubs.Select Gender' | translate }}</option>
                                  <option *ngFor="let item of genderList |keyvalue "
                                  value="{{item['key']}}">{{item['value']}}</option>
                                </select>
                                <div class="invalid-feedback">{{'submitdata.gender' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                              </td>
                              <td>
                                <span class="required-field-dfo" *ngIf="tabledata['officials'] == 'Divisional Forest Officer'">*</span>
                                <select style="width: 150px;" id="attendance_{{i}}" class="form-control custom-selectbox" [(ngModel)]="tabledata['attendance']"
                                (focusout)="focusEvent($event,tabledata['attendance'])" (keyup)="focusEvent($event,tabledata['attendance'])"
                                (ngModelChange)="checkAllFieldsChanged(tabledata)" [ngClass]="(status['attendance_'+i]) ? 'is-invalid' : ''">
                                  <option value="">{{ 'dataSubs.Select Attendance' | translate  }}</option>
                                  <option *ngFor="let item of attendanceList |keyvalue "
                                  value="{{item['key']}}">{{item['value']}}</option>
                                </select>
                                <div class="invalid-feedback">{{'submitdata.attendance' | translate }} {{'hardtable.Should Not Be Empty' | translate }}</div>
                              </td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                    </div>
                    <hr />
                    <div class="">

                      <div class=" flex-column w-100">
                        <h5 style="font-size: large;">{{'submitdata.minutesofmeeting' | translate }}<span class="required-field">*</span></h5>
                        <textarea class="w-100" [(ngModel)] = "attendanceFilter['mom']" rows="4"></textarea>

                      </div>

                      <div class="row">
                        <div class="col">
                          <div class="d-flex flex-column w-100">
                            <h5>{{'submitdata.uploadmom' | translate }}<span class="required-field">*</span></h5>
                            <span *ngIf = "filename != ''&& wrongFileCheck" style="color:red" >{{ 'hardtable.Please Enter valid Document' | translate }}</span>
                            <label *ngIf = "filename == ''" for="meeting_pics" class="form-control pointer">{{'submitdata.uploaddoc' | translate }}</label>
                            <label *ngIf = "filename != ''" for="meeting_pics" class="form-control pointer">{{filename}}</label>
                            <input  id="meeting_pics" (change) = "fileupload($event);fileValidation()" type="file"  value="Browse" name="Browse" hidden />
                            <button [disabled] = "!buttondisable" class="btn btn-danger" (click)="removeMinutesFile()"  type="submit">{{'submitdata.Remove' | translate}}</button>&nbsp;
                            <span class="mb-4">
                               <button [disabled] = "!buttondisable" type="button" (click) = "getanotherFile()"
                            class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                            </span>
                            <span *ngIf = "showfile">
                              <h5>{{'submitdata.uploadmom' | translate }}</h5>
                              <label *ngIf = "multiplefileName == ''"  for="meeting_pics1" class="form-control pointer">{{'submitdata.uploaddoc' | translate }}</label>
                              <label *ngIf = "multiplefileName != ''" for="meeting_pics1" class="form-control pointer">{{multiplefileName}}</label>
                              <input  id="meeting_pics1" (change) = "multipleFile($event);multiplefileValidation()" type="file"  value="Browse" name="Browse" hidden />&nbsp;&nbsp;
                            </span>
                            <span *ngIf = "showfile" >
                              <button  type="button" (click) = "getfileFilter()"
                           class="btn btn-danger"><i class="fa fa-minus"></i></button>
                           </span>
                          </div>

                          <div class="d-flex flex-column w-100">
                            <h5>{{'submitdata.uploadphoto' | translate }}</h5>
                            <span *ngIf = "imagename != '' && wrongimgflag" style="color:red" >{{ 'hardtable.Please Enter valid photo' | translate }}</span>
                            <label *ngIf = "imagename == ''" for="image_pics" class="form-control pointer">{{'submitdata.uploadphotoinput' | translate}}</label>
                            <label *ngIf = "imagename != ''" for="image_pics" class="form-control pointer">{{imagename}}</label>
                            <input id="image_pics"  (change)="imageupload($event);imageValidation();" type="file"  value="Browse" name="Browse" type="file" hidden />
                            <button [disabled] = "!imagedisable" class="btn btn-danger" (click)="removeMinutesPhoto()"  type="submit">{{'submitdata.Remove' | translate}}</button>&nbsp;
                            <span>
                              <button [disabled] = "!imagedisable" type="button" (click) = "getimageoption()"
                           class="btn btn-sm btn-info"><i class="fa fa-plus"></i></button>
                           </span>
                           <span *ngIf = "showimageoption">
                            <h5>{{'submitdata.uploadphoto' | translate }}</h5>
                            <label *ngIf = "multipleimageName == ''"  for="image_pics1" class="form-control pointer">{{'submitdata.uploadphotoinput' | translate }}</label>
                            <label *ngIf = "multipleimageName != ''" for="image_pics1" class="form-control pointer">{{multipleimageName}}</label>
                            <input  id="image_pics1" (change) = "multiplefileImages($event);imagemutilpleValidations();" type="file"  value="Browse" name="Browse" hidden />&nbsp;&nbsp;
                          </span>
                          <span *ngIf = "showimageoption">
                            <button  type="button" (click) = "getimageFilter()"
                         class="btn btn-danger"><i class="fa fa-minus"></i></button>
                         </span>
                          </div>
                          <!-- <div class="col">
                            <p class="mt-4"> (Please attach the Pictures of the meeting held in the document)</p>
                          </div>
                        </div> -->
                        </div>
                      <!-- <hr /> -->
                      <div class="col">
                        <div class="note">
                          {{'dataSubs.Note' | translate}} 
                        </div>
                      </div>
                        </div>
                    

                    <div class="row my-3">
                      <div class="col-12 d-flex justify-content-center ">
                        <button [disabled]="!itemAndDateSelected()" type="button" (click)="uploadFileData()" class="btn btn-info">{{'header.submit' | translate }}</button>&nbsp;&nbsp;
                        <button [disabled]="!itemAndDateSelected()" type="button" (click)="resetMeetingData()" class="btn btn-info">{{'submitdata.reset' | translate}}</button>
                      </div>
                      <!-- !itemselected && !dateSelected -->
                    </div>
                  </div>
                </div>
              
            </div>
            <div class="col-md-12 mt-10" align="center"
              *ngIf="(dynamiclabel || mediaLabels || solidwaste || ghatslabel || engagedlabel || gangagramlabel || afferostationlabel || migratorylabel || pondslabel || percentagelabel)">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcel()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="resetData()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center"
            *ngIf="(dynamicindLabel || inspectionlabel || authoritylabel || solidwastehotspot || plasticwastehotspot || adequatelabel || igolabel || soilconvlabel || stablisedlabel || gannurlabel || medicinelabel || capacitylabel || stpmanage || fecalsludge || regularmeetinglabel || dgclabel || gangaaarti || gangaapp || awarenesss || migratorylabel || gangasafety || yearlylabel || masterlabel || rivercentric || wastedumplabel || riverbanklabel || ngoLabel || cremtorialLabel || villagepop || swachsurukshen ||statuslabel || biodiversity ||budgetaccounts || vacancyaccounts || bhuvanapp)">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="dynamicIndicators()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="nonDynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="planlabel && indicatorThemes['value'] =='yes'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadPlanlabelData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="planlabelReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <!-- <div class="col-md-12 mt-10" align="center" *ngIf="planlabel && indicatorThemes['value'] =='no'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadplanData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="planlabelReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div> -->
             <div class="col-md-12 mt-10" align="center" *ngIf="planlabel && indicatorThemes['value'] =='no'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadplanData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="planlabelReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <!---------------------------------------------->
            <div class="col-md-12 mt-10" align="center" *ngIf="planlabel && indicatorThemes['value'] ==null">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadplanData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="planlabelReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>

            <div class="col-md-12 mt-10" align="center" *ngIf="gangalabel || educatinglabel">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadfiledataexcel()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="indicatorResetData()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
             <div class="col-md-12 mt-10" align="center" *ngIf="indicatorLabel">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcelBisunessData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="indicatordata">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcelriverData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="wetlandData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcelWetlandData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="springRejuvendData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcelSpringFile()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="GrossData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadgrossData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="industryData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcelindustryData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="nallaData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadNallaData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <!-- <div class="col-md-12 mt-10" align="center" *ngIf="stpData && indicatorThemes['value'] =='yes'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadsewaragedata()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div> -->
            <div class="col-md-12 mt-10" align="center" *ngIf="stpData && indicatorThemes['value'] ==null">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="radioNull()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="radioReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div> 
            <div class="col-md-12 mt-10" align="center" *ngIf="stpData && indicatorThemes['value'] =='yes'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadsewaragedata()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="stpData && indicatorThemes['value'] =='no'">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadfunctinaldata()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="stpPercentageData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadstp2Data()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="reusageWaterData">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadWaterData()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
            <div class="col-md-12 mt-10" align="center" *ngIf="meetingsDGC">
              <button class="btn btn-info pointer" [disabled]="disablebuttons" (click)="uploadexcel()"
                type="submit">{{'submitdata.save' | translate}}</button>
              <button class="btn btn-info ml-10" [disabled]="disablebuttons" (click)="dynamicReset()"
                type="submit">{{'submitdata.reset' | translate}}</button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
</div>

<ng-template #dataSubmissionModal>
  <div class="col">
    <button type="button" (click)="CloseVideoModal()" class="close" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="note">
        {{'dataSubs.Note2' | translate}}<br>
        {{'dataSubs.Note2_1' | translate}}<br>
        {{'dataSubs.Note2_2' | translate}}<br>
        {{'dataSubs.Note2_3' | translate}}<br>
        {{'dataSubs.Note2_4' | translate}}<br>
        {{ 'hardtable.click on' | translate }}  <a (click)="dataSubmRoute()" class="pointer" style="font-size: 23px; border: 2px solid #3bc3d5;">
          <i class="fa fa-user-check"></i></a>  {{ 'hardtable.to go to Data Submission.' | translate}}
     </div>
  </div>
</ng-template>
